export default __webpack_public_path__ + "static/education-equity-accomplishment-4-a9e8eb8361bed477cf2b7ce115fe4a86.webp";